import { __awaiter, __generator } from "tslib";
import { fetchCapabilities } from '@office-start/capabilities-service';
import { FileType } from '@office-start/document-types';
import { fetchLocStrings } from '@office-start/loc-service';
export function fetchCreateLinkCandidateForFileType() {
    return __awaiter(this, void 0, void 0, function () {
        var locStrings, capabilities, createLinkCandidates;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLocStrings()];
                case 1:
                    locStrings = _a.sent();
                    return [4 /*yield*/, fetchCapabilities()];
                case 2:
                    capabilities = _a.sent();
                    createLinkCandidates = new Map();
                    if (locStrings && capabilities) {
                        createLinkCandidates.set(FileType.Word, {
                            title: locStrings.linkCandidateResources.createMenuLinkWordTitle,
                            fileTypeName: locStrings.linkCandidateResources.createModalLinkWordTitle,
                            appName: locStrings.linkCandidateResources.wordName,
                            fileType: FileType.Word,
                            newDocName: locStrings.linkCandidateResources.newWordDocumentFileName,
                            fileExtension: 'docx',
                            workloadOnlineName: locStrings.linkCandidateResources.wordName,
                            canCreateBlankDocument: capabilities.createOneDriveDocApiEnabled,
                            canOpenBlankDocInNativeApp: true,
                            canFallbackToLandingPage: !capabilities.startPageApps.has(FileType.Word),
                            createDocAspxEnabled: capabilities.createDocAspxWordEnabled,
                            docAspxId: 1,
                        });
                        createLinkCandidates.set(FileType.Excel, {
                            title: locStrings.linkCandidateResources.createMenuLinkExcelTitle,
                            fileTypeName: locStrings.linkCandidateResources.createModalLinkExcelTitle,
                            appName: locStrings.linkCandidateResources.excelName,
                            fileType: FileType.Excel,
                            newDocName: locStrings.linkCandidateResources.newExcelWorkbookFileName,
                            fileExtension: 'xlsx',
                            workloadOnlineName: locStrings.linkCandidateResources.excelName,
                            canCreateBlankDocument: capabilities.createOneDriveDocApiEnabled,
                            canOpenBlankDocInNativeApp: false,
                            canFallbackToLandingPage: !capabilities.startPageApps.has(FileType.Excel),
                            createDocAspxEnabled: capabilities.createDocAspxExcelEnabled,
                            docAspxId: 2,
                        });
                        createLinkCandidates.set(FileType.PowerPoint, {
                            title: locStrings.linkCandidateResources
                                .createMenuLinkPowerPointTitle,
                            fileTypeName: locStrings.linkCandidateResources
                                .createModalLinkPowerPointTitle,
                            appName: locStrings.linkCandidateResources.powerpointName,
                            fileType: FileType.PowerPoint,
                            newDocName: locStrings.linkCandidateResources
                                .newPowerPointPresentationFileName,
                            fileExtension: 'pptx',
                            workloadOnlineName: locStrings.linkCandidateResources.powerpointName,
                            canCreateBlankDocument: capabilities.createOneDriveDocApiEnabled,
                            canOpenBlankDocInNativeApp: true,
                            canFallbackToLandingPage: !capabilities.startPageApps.has(FileType.PowerPoint),
                            createDocAspxEnabled: capabilities.createDocAspxPowerPointEnabled,
                            docAspxId: 3,
                        });
                        if (capabilities.startPageApps.has(FileType.Visio)) {
                            createLinkCandidates.set(FileType.Visio, {
                                title: locStrings.linkCandidateResources
                                    .createMenuLinkVisioTitle,
                                fileTypeName: locStrings.linkCandidateResources.createModalLinkVisioTitle,
                                appName: locStrings.linkCandidateResources.visioName,
                                fileType: FileType.Visio,
                                newDocName: locStrings.linkCandidateResources.newVisioDrawingFileName,
                                fileExtension: 'vsdx',
                                workloadOnlineName: locStrings.linkCandidateResources.visioName,
                                canCreateBlankDocument: capabilities.createOneDriveDocApiEnabled,
                                canOpenBlankDocInNativeApp: false,
                                canFallbackToLandingPage: false,
                                createDocAspxEnabled: capabilities.createDocAspxVisioEnabled,
                                docAspxId: 8,
                            });
                        }
                        else if (capabilities.createVisioEnabled) {
                            createLinkCandidates.set(FileType.Visio, {
                                title: locStrings.linkCandidateResources
                                    .createMenuLinkVisioTitle,
                                fileTypeName: locStrings.linkCandidateResources.createModalLinkVisioTitle,
                                appName: locStrings.linkCandidateResources.visioName,
                                fileType: FileType.Visio,
                                newDocName: locStrings.linkCandidateResources.newVisioDrawingFileName,
                                fileExtension: 'vsdx',
                                workloadOnlineName: locStrings.linkCandidateResources.visioName,
                                canCreateBlankDocument: capabilities.createOneDriveDocApiEnabled &&
                                    capabilities.createDocAspxVisioEnabled,
                                canOpenBlankDocInNativeApp: false,
                                canFallbackToLandingPage: true,
                                createDocAspxEnabled: capabilities.createDocAspxVisioEnabled,
                                docAspxId: 8,
                            });
                        }
                    }
                    return [2 /*return*/, createLinkCandidates];
            }
        });
    });
}
//# sourceMappingURL=fecthCreateLinkCandidates.js.map